import { render, staticRenderFns } from "./ModalEditClass.vue?vue&type=template&id=50d4e192&scoped=true"
import script from "./ModalEditClass.vue?vue&type=script&lang=js"
export * from "./ModalEditClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d4e192",
  null
  
)

export default component.exports